import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  styled,
  tableCellClasses,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { IProcurementRequirement } from 'types/lot/procurement-requirement'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
}))

type Props = {
  procurementRequirement: IProcurementRequirement
}

export const ProcurementResultSubmission = ({ procurementRequirement }: Props) => {
  const { t } = useTranslation()
  return (
    <TableContainer>
      <Table
        sx={{
          tableLayout: 'fixed',
          '& td, th': {
            border: '1px solid #ccc',
          },
        }}
      >
        <TableHead>
          <TableRow>
            <StyledTableCell>{t('evaluationOfDocuments')}</StyledTableCell>
            <StyledTableCell>{t('contractorOfferAndNotes')}</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>
              <Stack spacing={3}>
                <TextField
                  defaultValue={procurementRequirement.priceDescription}
                  disabled
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    rows: 2,
                    multiline: true,
                    inputComponent: 'textarea',
                  }}
                />
                <TextField
                  defaultValue={procurementRequirement.validityDurationDays}
                  disabled
                  label={t('tender-proposal-expiration-duration')}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  defaultValue={procurementRequirement.guaranteeAmount}
                  disabled
                  label={t('tender-proposal-warranty-amount')}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  defaultValue={procurementRequirement.guaranteeValidityDurationDays}
                  disabled
                  label={t('tender-proposal-validity-duration')}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  defaultValue={procurementRequirement.executionGuarantee}
                  disabled
                  label={t('warranty-of-procurement-contract-action')}
                  fullWidth
                  InputProps={{
                    rows: 2,
                    multiline: true,
                    inputComponent: 'textarea',
                  }}
                  InputLabelProps={{ shrink: true }}
                />
              </Stack>
            </TableCell>
            <TableCell>
              <Stack spacing={3}>
                <TextField
                  defaultValue={procurementRequirement.validityDurationDays}
                  disabled
                  label={t('tender-proposal-expiration-duration')}
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  defaultValue={procurementRequirement.guaranteeAmount}
                  disabled
                  label={t('tender-proposal-warranty-amount')}
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  defaultValue={procurementRequirement.guaranteeValidityDurationDays}
                  disabled
                  label={t('tender-proposal-validity-duration')}
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                />
              </Stack>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}
